define([
    'text!membership/component/main.html',
    'common/api',
    'jquery',
    'WebCommon/utils',




], function(
    tpl,Api,$,Utils
){
    return {
        template: tpl,
        data: function(){
            return {
                shops: {},
            };
        },
        components: {
        },
        computed: {

        },
        created: function () {
            var obj = this;


        },
        methods: {

            init: function ()
            {
                var obj = this;
                Api.getAllShops.ajax(
                    {

                    }).done(function (data)
                {
                    obj.shops = data.tableData;
                    Utils.emitPageReady();

                });
            },

        },
        mounted: function(){
            this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./membership/component/main.js
// module id = 163
// module chunks = 7